import {ExperimentNames} from '@wix/wix-events-commons-statics'
import {GetComponentDataParams, GetComponentDataResponse} from '../../shared-api'
import {createAsyncAction} from '../services/redux-toolkit'
import {updateNoEventsUrl, updateNoEventsUrlOld} from './navigation'

export const getComponentData = createAsyncAction<GetComponentDataResponse, GetComponentDataParams>(
  'GET_COMPONENT_DATA',
  async (params, {dispatch, extra: {serverApi, flowAPI}}) => {
    const component = await serverApi.getComponentData(params)

    if (params.viewMode !== 'editor') {
      flowAPI.experiments.enabled(ExperimentNames.UseEventsViewerReduxToolkit)
        ? dispatch(updateNoEventsUrl())
        : dispatch(updateNoEventsUrlOld())
    }

    return component
  },
)
